import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { LocationField } from '~src/spacesPlatform/components/tooltip/LocationField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, getPersonalSpaceLink, getProjectLink, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { User } from '~src/spacesPlatform/components/tooltip/User';

import { Messages } from '../../../codegen/Localize';
import { IDataRoleInfo } from '../../models/IDataRoleInfo';

export function DataRoleTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const projectLink = getProjectLink((props.content as IDataRoleInfo).project, urls);
  const personalSpaceLink = getPersonalSpaceLink(urls);
  const locationType = (props.content as IDataRoleInfo).location?.type;
  const ownerId = content.owner?.id;

  return (
    <Tooltip>
      <Name name={content.name} url={props.contentUrl}/>
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}/>
      <dl className={DetailsTooltipStyles.DescriptionList}>
        <LocationField inProjectSpace={props.inProjectSpace} inPersonalSpace={props.inPersonalSpace}
                       locationType={locationType}
                       projectLink={projectLink} personalSpaceLink={personalSpaceLink} contentOwnerId={ownerId}/>
        <User user={props.content.owner} label={Messages.owner()} urls={urls}/>
        <Timestamp label={Messages.modified()} value={props.content.updatedAt}/>
      </dl>
    </Tooltip>
);
}
